<template>
  <EnhancedQSelect
    :value="year"
    :options="years || []"
    :loading="!years"
    label="Start year of subscription period"
    dense
    class="q-ml-sm"
    @input="yearChanged"
  />
</template>

<script>
import * as apiTo from '@/modular-api'
// Components
import EnhancedQSelect from '@components/general/EnhancedQSelect'

export default {
  components: {
    EnhancedQSelect
  },

  props: {
    year: String
  },

  data: () => ({
    years: null
  }),

  created() {
    apiTo.GET_SUBSCRIPTION_PERIOD_START_YEARS().then(
      ({ data }) =>
        (this.years = data.result.map(y => ({
          label: String(y),
          value: String(y)
        })))
    )
  },

  methods: {
    yearChanged(newYear) {
      this.$router.push({ path: `/financial-periods?year=${newYear}` })
    }
  }
}
</script>
